import * as Schema from "effect/Schema";
import { Identifier } from "@linempo/kernel";
/** Scope is part of plan identity. Only timeline plans may be exported. */
export const PreviewTarget = Schema.Union([
    Schema.TaggedStruct("timeline", {}),
    Schema.TaggedStruct("animation", { animationId: Identifier }),
]);
export const TIMELINE_TARGET = Object.freeze({ _tag: "timeline" });
